import React from 'react';
import Carousel from 'react-multi-carousel';
import FirstImage from '../../assets/about-us-image-1.png';
import SecondImage from '../../assets/about-us-image-2.png';
import ThirdImage from '../../assets/about-us-image-3.png';
import { CAROUSEL_RESPONSIVE_SIZES_LOGO } from '../../utils/constants';
import { CarouselImage } from './LogoSection.styled';

import 'react-multi-carousel/lib/styles.css';

const LogoSection = () => {
  return (
    <div id="Home" style={{marginTop: 90}}>
      <Carousel responsive={CAROUSEL_RESPONSIVE_SIZES_LOGO} draggable swipeable infinite autoPlay autoPlaySpeed={4000} transitionDuration={500} removeArrowOnDeviceType={["tablet", "mobile"]}>
        <div style={{height: 'inherit'}}>
          <CarouselImage src={FirstImage} alt="Carousel Image" />
        </div>
        <div style={{height: 'inherit'}}>
          <CarouselImage src={SecondImage} alt="Carousel Image" />
        </div>
        <div style={{height: 'inherit'}}>
          <CarouselImage src={ThirdImage} alt="Carousel Image" />
        </div>
      </Carousel>
    </div>
  )
}

export default LogoSection